export default {
  RENTAL_MANAGER: 'rental-manager-app',
  RENTER_HUB: 'renter-hub-app',
  DEV_SERVER: 'dev-server-app',
};
